'use client';

import { useHeader } from '@/contexts/HeaderContext';
import { useEffect } from 'react';
import MarketTopic from './detail/event/MarketTopic';

export default function EventDetailPage({ id }: { id?: string }) {
  const { setShowBackButton } = useHeader();

  useEffect(() => {
    setShowBackButton(true);
    return () => setShowBackButton(false);
  }, [setShowBackButton]);

  return <MarketTopic id={id} />;
}
